import { MiddlewareAPI, Dispatch, Action } from 'redux'
import { getRequest, urlBuilder } from 'tfs.front-end-utils/requests'
import morphism, { StrictSchema } from 'morphism'

import ClientPassengerInterface from '../../interfaces/client/Passenger'
import ServerPassengerInterface from '../../interfaces/server/Passenger'

import staticData from '../../config/staticData'

import { FETCH_PASSENGERS } from '../../actions/passengers/fetchPassengers'
import { passengersFetched, addPassengers } from '../../actions/passengers'
import addNotification from '../../actions/notifications/addNotification'

import passengerSchema from '../../schemas/client/passenger'

import generateAuthorizationHeaders from '../../utils/requests/generateAuthorizationHeaders'
import customTourOperatorParameters from '../../utils/tourOperators/customTourOperatorParameters'
import { buildServerNotification } from '../../utils/notifications'
import { addPassengerSSRsToPassengers } from '../../utils/passengers'

export interface FetchPassengersActions extends Action {
  flightId: string
}

export default (store: MiddlewareAPI) => (next: Dispatch) => async (
  action: FetchPassengersActions
) => {
  next(action)
  if (action.type !== FETCH_PASSENGERS) {
    return
  }

  const dispatch = store.dispatch

  try {
    const {
      endpoints: {
        allotments: { url, headers },
      },
    } = staticData

    const fixedUrl = url.endsWith('/') ? url : `${url}/`
    const requestURL = urlBuilder(
      `${fixedUrl}${action.flightId}/passengers`,
      customTourOperatorParameters()
    )

    const authHeaders = await generateAuthorizationHeaders(headers)

    const passengersResponse = await getRequest(
      requestURL,
      {
        headers: { ...headers, ...authHeaders },
      },
      {
        requestCollection: true,
      }
    )

    //Initialize empty ssrs if null
    passengersResponse
      .filter((pr: ServerPassengerInterface) => pr.ssrs === null)
      .forEach((pr: ServerPassengerInterface) => pr.ssrs = [])

    const passengers = passengersResponse.map(
      (passenger: ServerPassengerInterface) =>
        morphism<
          StrictSchema<ClientPassengerInterface, ServerPassengerInterface>
        >(passengerSchema, passenger)
    )

    dispatch(addPassengers(passengers))
    dispatch(passengersFetched(passengers))

    addPassengerSSRsToPassengers(dispatch)(passengers)
  } catch (error) {
    dispatch(addNotification(buildServerNotification(error)))
  }
}
